import zsmLayout from '@/zsm-layout'
/* 商品服务  如开通抖音*/
const merchandiseRouter = {
  path: '/merchandise',
  component: zsmLayout,
  name: 'merchandise',
  redirect: '/merchandise/index',
  hidden: true,
  children: [
    {
      path: '/merchandise/index',
      component: () => import('@/view/merchandise/list'),
      name: 'merchandise'
    },
    {
      path: '/merchandise/detail',
      component: () => import('@/view/merchandise/detail'),
      name: 'merchandiseDetail'
    }
  ]
}

export default merchandiseRouter
